
import React, { useEffect, useState } from "react";
import { ImageOverlay, useMap } from "react-leaflet";
import L from "leaflet";
import cleanedUrl from "../../assets/classification-removebg.png"
const ClassOverlay = ({ coordinate,flag }) => {
   const [opacity, setOpacity] = useState(1); // Use opacity state here
  const map = useMap(); // Get the map instance

  // Reverse lat and long in the coordinates (i.e., from [lat, lng] to [lng, lat])
  const reverseCoordinates = (coordinates ) => {
    return coordinates.map((coordPair) => [coordPair[1], coordPair[0]]);
  };

  const reversedCoordinates = reverseCoordinates(coordinate);
  const polygon1 = {
    type: "Polygon",
    coordinates: [reversedCoordinates],
  };
  const bounds = L.geoJSON(polygon1).getBounds();

  useEffect(() => {
    // Check if coordinates are valid and non-empty
    if (coordinate && coordinate.length > 0 && coordinate[0].length > 0) {
      if (bounds.isValid()) {
        // Smoothly transition to the bounds of the polygon using flyToBounds
        map.flyToBounds(bounds);
      }
    }
  }, [coordinate, map]);
useEffect(() => {
  const storedOpacity = localStorage.getItem("opacity");
  if (storedOpacity) {
    setOpacity(Number(storedOpacity));
  }
}, []);

  // Poll every second for changes in localStorage
  useEffect(() => {
    const intervalId = setInterval(() => {
      const storedOpacity = localStorage.getItem("opacity");
      if (storedOpacity) {
        setOpacity(Number(storedOpacity)); // Update the state if localStorage value has changed
      }
    }, 1000); // Check every second

    // Clean up the interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []); // Empty dependency array to ensure this runs once when the component mounts


  return (
    <div>
      {/* Display the ImageOverlay only when cleanedUrl exists */}
      {flag && coordinate && coordinate.length > 0 && (
        <ImageOverlay
          url={cleanedUrl}
          bounds={bounds}
          opacity={opacity}
          interactive={true} // Allow interaction with the image
        />
      )}
    </div>
  );
};

export default React.memo(ClassOverlay);